import styled from '@emotion/styled';
import {colors} from './theme';

export const FloatingArrowStyles = styled.div`
    .dark:before,
    .dark:after {
        background-color: ${colors.gray[600]} !important;
        border-color: ${colors.gray[600]} !important;
    }
    .light:before,
    .light:after {
        background-color: ${colors.white} !important;
        border-color: ${colors.gray[200]} !important;
    }
    .arrow {
        height: 8px;
        width: 8px;
        :before,
        :after {
            border-bottom-width: 1px;
            border-right-width: 1px;
            border-style: solid;
            content: '';
            visibility: visible;
            height: 8px;
            width: 8px;
            position: absolute;
        }
    }
    .top {
        bottom: -5px;
        :before,
        :after {
            transform: rotate(45deg);
        }
    }
    .right {
        left: -5px;
        :before,
        :after {
            transform: rotate(135deg);
        }
    }
    .bottom {
        top: -5px;
        :before,
        :after {
            transform: rotate(-135deg);
        }
    }
    .left {
        right: -5px;
        :before,
        :after {
            transform: rotate(-45deg);
        }
    }
`;
